export enum InteractionPanelViewStates {
  Expanded = 'simx-expanded',
  Collapsed = 'simx-collapsed',
}
